import styled from 'styled-components'

const Wrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media (max-width: 480px) {
    padding: 16px;
    align-items: flex-start;
    padding-top: 20vh;
  }
`

const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  max-width: 520px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 480px) {
    max-height: 80vh;
    border-radius: 12px 12px 0 0;
  }
`

const Header = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.hasTitle ? 'space-between' : 'flex-end'};
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e5e5;
  flex-shrink: 0;
`

const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.2;
`

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;

  &:hover {
    background-color: #f5f5f5;
    color: #000;
  }

  &:active {
    background-color: #e5e5e5;
  }
`

const Content = styled.div`
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
`

const HighlightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 3px solid #0070d7;
`

const StarIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 24px;
    height: 24px;

    &,
    * {
      fill: #ffb800 !important;
      stroke: none !important;
    }

    path {
      fill: #ffb800 !important;
    }
  }
`

const HighlightText = styled.p`
  font-size: 16px;
  font-weight: 700;
  color: #0070d7;
  margin: 0;
  line-height: 1.4;
`

const Description = styled.p`
  font-size: 15px;
  color: #333;
  line-height: 1;
  margin-bottom: 20px;
  text-align: left;
  font-weight: 400;
`

const Subtitle = styled.p`
  font-size: 15px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 20px;
  text-align: left;
  font-weight: 500;
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: space-between;
  width: 100%;
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
  margin-top: auto;
  flex-shrink: 0;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 10px;
  }
`

const ModalButton = styled.button`
  flex: 1;
  background-color: #0070d7;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Soleil', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #005bb5;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 112, 215, 0.3);
  }

  &:active {
    background-color: #004a94;
    transform: translateY(0);
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 16px 24px;
  }
`

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 200px;
`

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #009af8;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const LoadingText = styled.p`
  font-size: 16px;
  color: #666;
  margin: 0;
`

export const Styled = {
  Wrap,
  ModalContent,
  Header,
  Title,
  CloseButton,
  Content,
  HighlightSection,
  StarIcon,
  HighlightText,
  Description,
  Subtitle,
  ButtonContainer,
  ModalButton,
  LoadingContainer,
  LoadingSpinner,
  LoadingText,
}
